import React, { useContext, useEffect } from "react";
import { DefaultPopupCard } from "./DefaultPopupCard";
import styled from "styled-components";
import LayoutContext from "../../../contexts/LayoutContext";
import PostNordIcon from "./../../../assets/images/postnordIcon.png";
import Arrow from "../../../assets/images/arrowUpRight.png";
import * as Formatter from "../../../utils/Formatter";
import Wolt from "../../../assets/images/vector0.svg";
import closeBtn from "../../../assets/images/close-btn.svg";
import Light from "../../../assets/images/lightning.png";
import EditPen from "../../../assets/images/edit-new-pen.svg";
import momentTimeZone from "moment-timezone";
import CourierInstructionsPopup from "./CourierInstructionPopup";
import UserContext from "../../../contexts/UserContext";

const InfoPopStyles = styled.div`
    .quick-buy-courier,
    .quick-buy-courier * {
        box-sizing: border-box;
    }
    .quick-buy-courier {
        background: var(--surface-surface-secondary, #121212);
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        box-shadow: var(--dropshadow-pop-up2-box-shadow, 4px 4px 87.4px 0px rgba(0, 0, 0, 1));
        overflow: hidden;
    }
    .frame-29643 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313569 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313568 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313474 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922840 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .info {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 22px;
        line-height: 28px;
        font-weight: 600;
        position: relative;
        flex: 1;
    }
    .frame-29057 {
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 30px;
        height: 30px;
        position: relative;
        overflow: visible;
    }
    .frame-295922845 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-3135682 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313547 {
        background: #151515;
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922844 {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922834 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .product-name {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var(--caption-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .vector {
        flex-shrink: 0;
        width: 28.2px;
        height: 16px;
        position: relative;
        overflow: visible;
        object-fit: cover;
    }
    .line-31 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-295922843 {
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .frame-295922841 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .frame-295922812 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313385 {
        display: flex;
        flex-direction: column;
        gap: 36px;
        align-items: flex-end;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .frame-313378 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .icon {
        border-radius: 0px;
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .edit {
        color: var(--text-text-brand, #f7665f);
        text-align: left;
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var(--caption-font-weight, 400);
        position: relative;
    }
    .frame-313567 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .product-name2 {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var(--caption-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .product-name3 {
        color: var(--text-text-primary, #ffffff);
        text-align: right;
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var(--caption-font-weight, 400);
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .line-34 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--border-border-primary-10, rgba(166, 166, 166, 0.1));
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-295922848 {
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .line-36 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--border-border-primary-10, rgba(166, 166, 166, 0.1));
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-295922846 {
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .product-name4 {
        color: var(--text-text-primary, #ffffff);
        text-align: right;
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var(--caption-font-weight, 400);
        text-decoration: underline;
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .frame-295922873 {
        background: var(--surface-surface-tertiary, #212121);
        border-radius: 5px;
        padding: 0px 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 64px;
        position: relative;
    }
    .product-name5 {
        text-align: left;
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var(--caption-font-weight, 400);
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .product-name-5-span {
        color: var(--text-text-success, #69c23f);
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var(--caption-font-weight, 400);
    }
    .product-name-5-span2 {
        color: var(--text-text-secondary, #8c8c8c);
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var (--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var (--caption-font-weight, 400);
    }
    .frame-313658 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922839 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922838 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .separator {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .line-27 {
        margin-top: -0.5px;
        border-style: solid;
        border-color: var(--border-border-tertiary, #373737);
        border-width: 0.5px 0 0 0;
        flex: 1;
        height: 0px;
        position: relative;
        transform-origin: 0 0;
        transform: rotate(0.001deg) scale(1, 1);
    }
    .text-label-here {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: center;
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var(--caption-font-weight, 400);
        position: relative;
    }
    .line-26 {
        margin-top: -0.5px;
        border-style: solid;
        border-color: var(--border-border-tertiary, #373737);
        border-width: 0.5px 0 0 0;
        flex: 1;
        height: 0px;
        position: relative;
        transform-origin: 0 0;
        transform: rotate(0.001deg) scale(1, 1);
    }
    .frame-3133852 {
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-29432 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
        width: 372px;
        height: 41px;
        position: relative;
    }
    .price {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        position: relative;
        flex: 1;
        height: 24px;
    }
    .price-span {
        color: var(--text-text-primary, #ffffff);
        font-family: "OpenSans-Bold", sans-serif;
        font-size: 24px;
        line-height: 24px;
        font-weight: 700;
    }
    .price-span2 {
        color: var(--text-text-primary, #ffffff);
        font-family: "OpenSans-Bold", sans-serif;
        font-size: 30px;
        line-height: 24px;
        font-weight: 700;
    }
    .price-span3 {
        color: var (--text-text-primary, #ffffff);
        font-family: "OpenSans-Bold", sans-serif;
        font-size: 18px;
        line-height: 24px;
        font-weight: 700;
    }
    .btn-md-solid {
        background: var(--buttons-button-primary, #f7665f);
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 48px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
    }
    .frame-313497 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .lightning-02 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-313349 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-medium-regular-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-medium-regular-font-size, 14px);
        line-height: var(--button-text-medium-regular-line-height, 24px);
        font-weight: var(--button-text-medium-regular-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .by-placing-order-you-agree-to-the-terms-privacy-policy-of-b-otag-norge-as {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: center;
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 10px);
        line-height: var(--caption-line-height, 16px);
        font-weight: var(--caption-font-weight, 400);
        position: relative;
        align-self: stretch;
    }
    .by-placing-order-you-agree-to-the-terms-privacy-policy-of-b-otag-norge-as-span {
        color: var(--text-text-secondary, #8c8c8c);
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 10px);
        line-height: var(--caption-line-height, 16px);
        font-weight: var(--caption-font-weight, 400);
    }
    .by-placing-order-you-agree-to-the-terms-privacy-policy-of-b-otag-norge-as-span2 {
        color: var(--text-text-secondary, #8c8c8c);
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 10px);
        line-height: var(--caption-line-height, 16px);
        font-weight: var(--caption-font-weight, 400);
        text-decoration: underline;
    }
    .by-placing-order-you-agree-to-the-terms-privacy-policy-of-b-otag-norge-as-span3 {
        color: var(--text-text-secondary, #8c8c8c);
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 10px);
        line-height: var(--caption-line-height, 16px);
        font-weight: var(--caption-font-weight, 400);
    }
    .by-placing-order-you-agree-to-the-terms-privacy-policy-of-b-otag-norge-as-span4 {
        color: var(--text-text-secondary, #8c8c8c);
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 10px);
        line-height: var(--caption-line-height, 16px);
        font-weight: var(--caption-font-weight, 400);
        text-decoration: underline;
    }
    .by-placing-order-you-agree-to-the-terms-privacy-policy-of-b-otag-norge-as-span5 {
        color: var(--text-text-secondary, #8c8c8c);
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 10px);
        line-height: var(--caption-line-height, 16px);
        font-weight: var (--caption-font-weight, 400);
    }
`;

const InfoPopup = () => {
    const {
        showInfoPopup,
        setShowInfoPopup,
        setShowStoreInformation,
        setQuickBuyPopup,
        setStoreInformation,
        setShowShippingAddressPopup,
        setShowCourierInstructionPopup,
        showCourierInstructionPopup,
        courierInstructionsData,
        setShippingAddressPopupData
    } = React.useContext(LayoutContext);
    const { shippingRecipient, setQuickBuyData } = useContext(UserContext);

    const type = showInfoPopup?.data?.deliveryOption.toLowerCase();
    const userAddress =
        showInfoPopup?.data?.deliveryInstructions?.address +
        " " +
        showInfoPopup?.data?.deliveryInstructions?.postcode +
        " " +
        showInfoPopup?.data?.deliveryInstructions?.city +
        ", " +
        showInfoPopup?.data?.deliveryInstructions?.countryName;
    const storeData = showInfoPopup?.data?.storeID;
    const storeAddress = storeData?.name;
    const instruction = courierInstructionsData[showInfoPopup?.data?.itemID];

    const recipient =
        (shippingRecipient?.firstName === null && shippingRecipient?.lastName === null) || shippingRecipient?.company === null;

    const isStoreOpen = () => {
        const dayOfWeek = new Date().toLocaleString("en-us", { weekday: "long" }).toLowerCase();
        const openHours = storeData?.openHours?.[dayOfWeek];

        if (!openHours || openHours.closedAllDay) return false;
        if (openHours.openAllDay) return true;

        const currentTime = momentTimeZone.tz("Europe/Oslo").format("HH:mm");
        const hourStart = openHours?.hourStart; // "10:00"
        const hourEnd = openHours?.hourEnd; // "19:00"
        return currentTime >= hourStart && currentTime <= hourEnd;
    };
    const showStoreinfoFunc = (storeDetails, notToShow) => {
        setStoreInformation(storeDetails);
        if (notToShow) {
            setShowStoreInformation(false);
        } else {
            setShowStoreInformation(true);
        }
    };
    const onEditRecipientClick = item => {
        setShippingAddressPopupData(item.itemID);
        setShowShippingAddressPopup(true);
    };

    const handleQuickBuy = () => {
        setShowInfoPopup({
            state: false,
            data: showInfoPopup?.data,
            lastOpenState: true
        });
        setQuickBuyPopup(true);
        setQuickBuyData(prevState => {
            return {
                ...prevState,
                items: [showInfoPopup?.data],
                total: showInfoPopup?.data?.FormattedData.totalPrice
            };
        });
    };
    useEffect(() => {
        showStoreinfoFunc(showInfoPopup?.data?.storeID, true);
    }, []);
    return (
        <DefaultPopupCard mobileUsesFullScreen={false}>
            <InfoPopStyles>
                {showCourierInstructionPopup && (
                    <CourierInstructionsPopup item={showInfoPopup?.data} itemID={showInfoPopup?.data?.itemID} />
                )}

                <div className="frame-29643">
                    <div className="frame-313569">
                        <div className="frame-313568">
                            <div className="frame-313474">
                                <div className="frame-295922840">
                                    <div className="info">Info</div>
                                </div>
                                <img
                                    className="frame-29057"
                                    src={closeBtn}
                                    onClick={() =>
                                        setShowInfoPopup({
                                            state: false,
                                            data: null,
                                            lastOpenState: false
                                        })
                                    }
                                    alt=""
                                />
                            </div>
                            <div className="frame-295922845">
                                <div className="frame-3135682">
                                    <div className="frame-313547">
                                        <div className="frame-295922844">
                                            {type === "pickup" ? (
                                                <TypePickUpInfo
                                                    storeAddress={storeAddress}
                                                    showStoreinfoFunc={showStoreinfoFunc}
                                                    setShowInfoPopup={setShowInfoPopup}
                                                    showInfoPopup={showInfoPopup}
                                                />
                                            ) : (
                                                <TypeShippingAndCourierInfo type={type} BOTagAlgData={showInfoPopup} />
                                            )}
                                        </div>
                                        <div className="line-31"></div>
                                        {type === "pickup" ? (
                                            <PickupDeliveryComponent BOTagAlgData={showInfoPopup} />
                                        ) : (
                                            <ShippingAndCourierDeliveryComponent
                                                userAddress={userAddress}
                                                type={type}
                                                instruction={instruction}
                                                recipient={recipient}
                                                setShowCourierInstructionPopup={setShowCourierInstructionPopup}
                                                setShowInfoPopup={setShowInfoPopup}
                                                showInfoPopup={showInfoPopup}
                                                onEditRecipientClick={onEditRecipientClick}
                                                shippingRecipient={shippingRecipient}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="frame-313567">
                                    <div className="frame-313567">
                                        <div className="frame-313547">
                                            <div className="frame-295922843">
                                                <div className="product-name2">Product name</div>
                                                <div className="product-name3">{showInfoPopup?.data?.productDetails?.name}</div>
                                            </div>
                                            <div className="line-34"></div>
                                            <div className="frame-295922848">
                                                <div className="product-name2">Store name</div>
                                                <div className="product-name3">{storeData?.name}</div>
                                            </div>
                                            <div className="line-36"></div>
                                            <div className="frame-295922846">
                                                <div className="product-name2">Opening hours</div>
                                                <div
                                                    className="product-name4"
                                                    style={{ color: "rgba(247, 102, 95, 1)", cursor: "pointer" }}
                                                    onClick={() => {
                                                        showStoreinfoFunc(storeData);
                                                        setShowInfoPopup({
                                                            state: false,
                                                            data: showInfoPopup?.data,
                                                            lastOpenState: true
                                                        });
                                                    }}>
                                                    See opening hours
                                                </div>
                                            </div>
                                            <div className="frame-295922873">
                                                <div className="product-name5">
                                                    <span>
                                                        <span
                                                            className="product-name-5-span"
                                                            style={{ color: isStoreOpen() ? "#69c23f" : "#ff0000" }}>
                                                            {isStoreOpen() ? " Open " : "Closed"}
                                                        </span>
                                                        <span className="product-name-5-span2">
                                                            {type === "pickup"
                                                                ? isStoreOpen()
                                                                    ? " . Pick up today or any other day during store opening hours."
                                                                    : " . Order now and pick up when store opens again."
                                                                : type === "courier"
                                                                ? isStoreOpen()
                                                                    ? " . Wolt will deliver to you after the store handles your order."
                                                                    : " . Order now and Wolt will deliver to you when store opens again."
                                                                : type === "shipping"
                                                                ? isStoreOpen()
                                                                    ? " . You will receive a tracking link when the order is shipped."
                                                                    : " . You can still order now. You will receive a tracking link when the order is shipped."
                                                                : ""}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="frame-313658">
                            <div className="frame-295922839">
                                <div className="frame-295922838">
                                    <div className="separator">
                                        <div className="line-27"></div>
                                        <div className="text-label-here">
                                            Item price{" "}
                                            {type === "pickup"
                                                ? ""
                                                : `${Formatter.formatPrice(showInfoPopup?.data?.currentItemPrice)} NOK `}
                                            {type === "pickup"
                                                ? ""
                                                : `/ Delivery
                                            ${
                                                showInfoPopup?.data?.deliveryCost === 0
                                                    ? " FREE today"
                                                    : ` ${Formatter.formatPrice(showInfoPopup?.data?.deliveryCost)} NOK`
                                            }`}
                                        </div>
                                        <div className="line-26"></div>
                                    </div>
                                    <div className="frame-3133852">
                                        <div className="frame-29432">
                                            <div className="price">
                                                <span>
                                                    <span className="price-span">
                                                        {Formatter.formatPrice(
                                                            showInfoPopup?.data?.currentItemPrice + showInfoPopup?.data?.deliveryCost
                                                        )}
                                                    </span>
                                                    <span className="price-span2"> </span>
                                                    <span className="price-span3">NOK</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-md-solid cursor-pointer" onClick={handleQuickBuy}>
                                    <div className="frame-313497">
                                        <img className="lightning-02" src={Light} alt="" />
                                        <div className="frame-313349">
                                            <div className="button">Quick buy this item only</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </InfoPopStyles>
        </DefaultPopupCard>
    );
};

export default InfoPopup;

const TypePickUpInfo = ({ storeAddress, showStoreinfoFunc, setShowInfoPopup, showInfoPopup }) => {
    return (
        <>
            <div className="frame-295922834">Pick-up at {storeAddress}</div>
            <div
                className="product-name"
                style={{ gap: "2px", color: "rgba(105, 194, 63, 1)", cursor: "pointer" }}
                onClick={() => {
                    showStoreinfoFunc(showInfoPopup?.data?.storeID);
                    setShowInfoPopup({
                        state: false,
                        data: showInfoPopup?.data,
                        lastOpenState: true
                    });
                }}>
                <img src={Arrow} alt="" height={"12px"} /> Opening hours
            </div>
        </>
    );
};

const TypeShippingAndCourierInfo = ({ type, BOTagAlgData }) => {
    return (
        <>
            <div className="frame-295922834">
                <div className="product-name">{type === "courier" ? "Delivery by" : "Shipping by"}</div>
                {type === "courier" ? <img className="vector" src={Wolt} alt="" /> : null}
                {type === "shipping" ? <img style={{ height: "10px" }} src={PostNordIcon} alt="" /> : null}
            </div>
            <div className="product-name">
                {Formatter.formatPrice(
                    BOTagAlgData?.data?.itemDiscountPercentage
                        ? BOTagAlgData?.data?.currentItemPrice
                        : BOTagAlgData?.data?.originalItemPrice
                )}{" "}
                NOK
            </div>
        </>
    );
};

const PickupDeliveryComponent = ({ BOTagAlgData }) => {
    return (
        <div className="frame-295922843">
            <div className="frame-295922841" style={{ color: "rgba(140, 140, 140, 1)" }}>
                <div style={{ lineHeight: "22px" }}>
                    <div style={{ color: "rgba(140, 140, 140, 1)" }}>Store address:</div>
                    <div>
                        {BOTagAlgData?.data?.storeID?.address} {BOTagAlgData?.data?.storeID?.addressNumber}{" "}
                        {BOTagAlgData?.data?.storeID?.city}, {BOTagAlgData?.data?.storeID?.country}
                    </div>
                </div>
            </div>
        </div>
    );
};

const ShippingAndCourierDeliveryComponent = ({
    userAddress,
    type,
    instruction,
    recipient,
    setShowCourierInstructionPopup,
    setShowInfoPopup,
    showInfoPopup,
    onEditRecipientClick,
    shippingRecipient
}) => {
    return (
        <div className="frame-295922843">
            <div className="frame-295922841">
                <div style={{ lineHeight: "22px" }}>
                    <div style={{ color: "rgba(140, 140, 140, 1)" }}>Deliver to:</div>
                    <div>{userAddress}</div>
                    {type === "courier" ? (
                        <div style={{ color: "rgba(140, 140, 140, 1)" }}>{instruction ? instruction : "(No instructions added)"}</div>
                    ) : null}
                    {type === "shipping" ? (
                        <div style={{ color: "rgba(140, 140, 140, 1)" }}>
                            {!recipient
                                ? `(${shippingRecipient?.firstName || ""} ${shippingRecipient?.lastName || ""}${
                                      shippingRecipient?.company ? ` / ${shippingRecipient?.company}` : ""
                                  })`
                                : "(No recipient added)"}
                        </div>
                    ) : null}
                </div>
                <div
                    className="frame-295922812"
                    onClick={() => {
                        if (type === "courier") {
                            setShowCourierInstructionPopup(true);
                        } else if (type === "shipping") {
                            setShowInfoPopup({
                                state: false,
                                data: showInfoPopup?.data,
                                lastOpenState: true
                            });
                            onEditRecipientClick(showInfoPopup?.data);
                        }
                    }}>
                    <div className="frame-313385">
                        <div className="frame-313378">
                            <img className="icon" src={EditPen} alt="" />
                            <div className="edit">Edit</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
